/** Tema claro/oscuro: preferencia local del usuario; el branding sólo da el defecto. */
export type Tema = 'claro' | 'oscuro';

const CLAVE = 'pm_tema';

export function temaGuardado(): Tema | null {
  const v = localStorage.getItem(CLAVE);
  return v === 'oscuro' || v === 'claro' ? v : null;
}

export function temaActual(): Tema {
  return document.documentElement.dataset['tema'] === 'oscuro' ? 'oscuro' : 'claro';
}

export function aplicarTema(tema: Tema, persistir = true): void {
  if (tema === 'oscuro') document.documentElement.dataset['tema'] = 'oscuro';
  else delete document.documentElement.dataset['tema'];
  if (persistir) localStorage.setItem(CLAVE, tema);
}

export function alternarTema(): Tema {
  const nuevo: Tema = temaActual() === 'oscuro' ? 'claro' : 'oscuro';
  aplicarTema(nuevo);
  return nuevo;
}

/** Al arrancar: preferencia guardada > modoOscuro del branding > claro. */
export function iniciarTema(modoOscuroBranding?: boolean): void {
  const guardado = temaGuardado();
  if (guardado) aplicarTema(guardado, false);
  else if (modoOscuroBranding) aplicarTema('oscuro', false);
}
